import React, { useState, useEffect } from 'react';
import { Card, Spin, Switch, Row, Col, Button, Modal } from 'antd';
import './AmPermissionsView.css';

const AmPermissionsView = (props) => {
  const {
    allGroupsData, allGroupsLoading, permissionsLoading,
    selectedGroupIds, onUpdate, updateLoading, permissionsData,
    isAmOfOrg, orgData
  } = props;

  const allGroups = allGroupsData?.getAllGroups?.edges || [];
  const [pendingGroupIds, setPendingGroupIds] = useState(selectedGroupIds || []);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setPendingGroupIds(selectedGroupIds || []);
  }, [selectedGroupIds]);

  const handleToggleGroup = (groupId) => {
    setPendingGroupIds(prev =>
      prev.includes(groupId)
        ? prev.filter(id => id !== groupId)
        : [...prev, groupId]
    );
  };

  const handleUpdate = () => {
    if (isAmOfOrg) {
      setModalVisible(true);
      return;
    }
    if (onUpdate) onUpdate(pendingGroupIds);
  };
  const handleModalClose = () => {
    setModalVisible(false);
    setPendingGroupIds(selectedGroupIds || []);
  };
  if (allGroupsLoading || permissionsLoading) return <Spin style={{ width: '100%', height: '75vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />;

  const orgLogo = permissionsData?.organizationById?.logo;
  const orgName = permissionsData?.organizationById?.name;
  const info_logo = "https://res.cloudinary.com/mapp-brainayan-app/image/upload/v1752157106/MApp/UI/SVGs/am_perm_info_icon_ft47lt.svg"

  return (
    <div style={{ padding: '2em' }}>
      <div className="am-permissions-header-row">
        <div className="am-permissions-org-row">
          {orgLogo && (
            <img src={orgLogo} alt={orgName} style={{ height: 64, width: 'auto', maxWidth: 180, objectFit: 'contain', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #f0f1f2', marginRight: 16 }} />
          )}
          {orgName && (
            <span style={{ fontSize: '2em', fontWeight: 700 }}>{orgName}</span>
          )}
        </div>
        <div className="am-permissions-info-row">
          <img src={info_logo} alt="!" style={{ width: '1.4em', height: '1.4em' }} />
          <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            <i className="anticon anticon-info-circle" style={{ color: '#4ccb1f', fontSize: 20, marginRight: 8 }} />
            Here you can manage all the permissions!
          </span>
        </div>
      </div>
      {/* Permissions cards */}
      <Row gutter={[24, 24]}>
        {allGroups.map(({ node }) => {
          const isChecked = pendingGroupIds.includes(node.id);
          return (
            <Col xs={24} sm={24} md={12} lg={12} key={node.id}>
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: '0px 0.75em 0.89em 0px #AABAC633',
                  marginBottom: 16,
                  background: '#fff',
                  border: 'none',
                }}
                bodyStyle={{ padding: 0 }}
                title={
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 0 }}>
                    <span style={{ fontWeight: 600, whiteSpace: 'normal', wordBreak: 'break-word' }}>{node.name}</span>
                    <Switch
                      checked={isChecked}
                      onChange={() => handleToggleGroup(node.id)}
                      checkedChildren=""
                      unCheckedChildren=""
                      className="custom-permission-switch"
                      style={{ marginLeft: 12 }}
                    />
                  </div>
                }
                bordered={false}
              >
              </Card>
            </Col>
          );
        })}
      </Row>
      <div style={{ textAlign: 'right', marginTop: 24 }}>
        <Button
          className="am-permissions-update-btn"
          loading={updateLoading}
          onClick={handleUpdate}
          disabled={!orgData}
        >
          Update
        </Button>
      </div>
      <Modal
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        centered
      >
        <div style={{ display: "flex", flexDirection: 'column', alignItems:'center' }}>
        <div style={{ textAlign: 'center', fontWeight: 600, fontSize: "120%", color: '#3D96FF', width:'90%' }}>
          Sorry, you cannot assign permissions to the org of which you are an employee
        </div>
        <Button className="am-perm-cancel-btn" type="primary" onClick={handleModalClose} style={{ marginTop: 16, width:'30%' }}>
          OK
        </Button>
        </div>
      </Modal>
    </div>
  );
};

export default AmPermissionsView;